import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

// Connects to data-controller="engage--banner"
export default class extends Controller {
  static targets = ["container"]
  static values = { flowId: String }

  #abortController = null
  #removeTimer = null

  connect() {
    this.#abortController = new AbortController()
    void this.#startFlow()
  }

  disconnect() {
    this.#abortController?.abort()
    if (this.#removeTimer) clearTimeout(this.#removeTimer)
  }

  async complete() {
    const stepKey =
      this.element.querySelector("[data-step-key]")?.dataset.stepKey
    if (stepKey) {
      await this.#patch(
        `/api/v1/engage/flow_states/${this.flowIdValue}/complete_step`,
        {
          step_key: stepKey,
        },
      )
    }
    this.#remove()
  }

  async dismiss() {
    await this.#patch(`/api/v1/engage/flow_states/${this.flowIdValue}/dismiss`)
    this.#remove()
  }

  // ── Private ──────────────────────────────────────────────────────────────

  async #startFlow() {
    await this.#patch(`/api/v1/engage/flow_states/${this.flowIdValue}/start`)
  }

  #remove() {
    this.element.style.transition = "opacity 200ms"
    this.element.style.opacity = "0"
    this.#removeTimer = setTimeout(() => this.element.remove(), 200)
  }

  async #patch(url, body = null) {
    try {
      const options = { credentials: "include", responseKind: "json" }
      if (this.#abortController) options.signal = this.#abortController.signal
      if (body) options.body = body
      const response = await patch(url, options)
      if (!response.ok)
        console.error(`[Engage] API error ${response.statusCode}`, url)
      return response
    } catch (e) {
      if (e.name !== "AbortError") throw e
    }
  }
}
